import { useEffect, useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PatientTab } from "@/Common/Models/Patient/PatientEnums";
import { Relative } from "../Models/Relative";
import { RelativeFileUIModel } from "../Models/UI/RelativeFileUIModel";
import { relativeStore } from "../Stores/RelativeStore";
import { ProfileView } from "./ProfileView";
import { RelativeBanner } from "./RelativeBanner";

import styles from "./RelativeTab.module.scss";

function RelativeTab(): JSX.Element {
    useEffect(() => {
        $(window).trigger("resize");
    });

    const { getText } = useTranslation();

    const [relative, setRelative] = useState<Relative>(relativeStore.GetCurrent());
    const [relativeFile, setRelativeFile] = useState<RelativeFileUIModel>(relativeStore.GetCurrentFile());

    const relativeStoreListenerRef = relativeStore.AddChangeListener(() => {
        setRelative(relativeStore.GetCurrent());
        setRelativeFile(relativeStore.GetCurrentFile());
    }, this, "relativeTab-listener");

    useEffect(() => () => {
        relativeStore.RemoveListener(relativeStoreListenerRef);
    }, [relativeStoreListenerRef]);

    if (!relative || !relativeFile || !sessionStore.selectedFile || sessionStore.selectedFile.ContactId !== relative.ContactId) {
        // in case a session store event fire before the relative store is ready.
        return null;
    }

    return (
        <>
            <div className="myle-page-header bottom-border">
                <RelativeBanner
                    person={relative}
                    relativeFile={relativeFile}
                    isReadOnly={true}
                    isMSAActive={sessionStore.isMsaActive}
                />
            </div>
            <div className="fxheight hide-overflow">
                <div className={styles.relativeProfile} data-cy="patient-tab">
                    <div>
                        <ProfileView relative={relative} model={relativeFile} />
                    </div>
                    <ul className="vnav">
                        <li className="nav-icon profile">
                            <a
                                title={getText("PatientProfileLabel")}
                                data-cy={`patientTab-${PatientTab.Profile.toString().toLowerCase()}`}
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export { RelativeTab };
